import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {OrderProcessorSearchModel} from "../order-processor-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-order-processor-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(OrderProcessorSearchModel),
        registerSearchControl(OrderProcessorMultiSelectSearchControlComponent)
    ]
})
export class OrderProcessorMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<OrderProcessorSearchModel> implements OnInit {
    @Input() capability: string;

    constructor(model: OrderProcessorSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }

    ngOnInit(): void {
        this.model.filter[OrderProcessorSearchModel.CAPABILITY_FILTER_NAME] = this.capability;
    }
}
